// assets/autoplay-first-video.js
document.addEventListener('DOMContentLoaded', () => {
  /* 1. premier deferred-media à l’intérieur du viewer */
  const dm = document.querySelector(
    '[id^="GalleryViewer"] deferred-media[data-media-id]'
  );
  if (!dm) return;                               // pas de vidéo => on sort

  /* 2. force Shopify à injecter le contenu <template> */
  if (typeof dm.loadContent === 'function') dm.loadContent(false);
  else if (typeof dm.load === 'function') dm.load(false);    // Dawn ≥ 11

  /* 3. fonction qui règle et joue une balise vidéo */
  const playVideo = (vid) => {
    if (!vid) return;
    vid.muted = true;
    vid.playsInline = true;
    vid.autoplay = true;
    vid.loop = true;
    vid.preload = 'auto';
    const tryPlay = () => vid.play().catch(() => {});
    vid.addEventListener('canplaythrough', tryPlay, { once: true });
    setTimeout(tryPlay, 400);                     // secours iOS

    /* masque l’overlay ▶ */
    const poster = dm.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';
  };

  /* 4. vidéo déjà injectée ? */
  const immediate = dm.querySelector('video');
  if (immediate) return playVideo(immediate);

  /* 5. sinon on observe l’arrivée future du <video> */
  const obs = new MutationObserver((mut, obsr) => {
    mut.forEach((m) =>
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1 && n.tagName === 'VIDEO') {
          playVideo(n);
          obsr.disconnect();
        }
      })
    );
  });
  obs.observe(dm, { childList: true, subtree: true });
});
